<mat-chip
  [matTooltip]="user.profile.fullName + ' - ' + user.email"
  [disableRipple]="true"
  class="bg-primary-50 flex items-center"
  [selectable]="false">

  <img
    matChipAvatar
    *ngIf="user?.profile?.avatarUrl; else noAvatar"
    [ngSrc]="user.profile.avatarUrl"
    [width]="5"
    [height]="5"
    [alt]="user.profile.fullName"
  />

  <ng-template #noAvatar>
    <span matChipAvatar>
      <mat-icon>person</mat-icon>
    </span>
  </ng-template>

  <span class="text-xs leading-none">{{ user.profile?.fullName }}</span>

  <ng-container>
    <button
      *ngIf="!hideRemoveAction"
      matChipRemove
      appConfirmDialog
      [confirmMessage]="'Do you really want to remove this person?'"
      (ok)="removeUser(user)">
      <mat-icon>cancel</mat-icon>
    </button>
  </ng-container>
</mat-chip>
